<template>
  <div class="row guarantee">
    <div class="col-xs-3 col-sm-2 col-sm-offset-5 col-md-4 col-md-offset-4">
      <img
        :src="imgSatisfactionGuaranteedBadge"
        class="responsive-img"
        alt="Satisfaction Guaranteed Badge"
      >
    </div>
    <div class="col-xs-9 col-sm-12">
      <p class="guarantee__text">
        {{ pageData.resourceStrings.satisfactionGuarantee }}
      </p>
    </div>
  </div>
</template>

<script>
import imgSatisfactionGuaranteedBadge from '../assets/satisfaction-guarantee-badge.png'

export default {
  name: 'SiteFooterGuarantee',
  props: {
    pageData: { type: Object, default: null, required: true }
  },
  data () {
    return {
      imgSatisfactionGuaranteedBadge
    }
  }
}
</script>

<style lang="scss" scoped>
.guarantee {
  margin: 0 0 20px;
  padding: 0 0 10px 0;
  border-bottom: 1px solid #d8dbde;

  @media screen and (min-width: $screen-md-min) {
    margin: 0;
    padding: 0;
    border-bottom: none;
  }

  &__text {
    color: #4c7399;
    font-family: $font-circular-std;
    font-size: 1.1rem;
    font-weight: bold;
    margin: 0 0 20px;
    padding-top: 1rem;

    @media screen and (min-width: $screen-sm-min) {
      text-align: center;
      padding-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/site-footer/components/SiteFooterGuarantee.vue